<script lang="ts">
import {defineComponent, PropType} from 'vue'
import {PagerLinkItem} from "@/types";
import {mapActions} from "vuex";

export default defineComponent({
    name: "PagerLinkItem",
    props: {
        pagerItem: {
            type: Object as PropType<PagerLinkItem>,
            required: true,
        },
        key: {
            type: String,
            required: true,
        }
    },
    methods: {
        ...mapActions({
            loadProducts: 'LOAD_PRODUCTS',
        }),
        changePage(url: string) {
            this.loadProducts({url: url});
        },
    }
})
</script>

<template>
    <button :key="key" :class="pagerItem.class"
            @click="changePage(pagerItem.href)"
            :title="`${pagerItem.text}`" type="button">
        <span v-if="pagerItem.icon" v-html="pagerItem.icon" class="icon"></span>
        <span v-else>{{ pagerItem.text }}</span>
    </button>
</template>